
import { ReactNode } from "react";
import { AuthContext } from "./auth/AuthContext";
import { useAuthState } from "./auth/useAuthState";
import { AuthContextType } from "./auth/types";

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const {
    user,
    isLoading,
    error,
    login,
    register,
    logout,
    getAccessToken,
    forgotPassword,
    resetPassword,
    updateProfile
  } = useAuthState();

  const authValue: AuthContextType = {
    user,
    isAuthenticated: !!user,
    isLoading,
    error,
    login,
    register,
    logout,
    getAccessToken,
    forgotPassword,
    resetPassword,
    updateProfile
  };

  return (
    <AuthContext.Provider value={authValue}>
      {children}
    </AuthContext.Provider>
  );
}

import { useContext } from "react";

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
